import React from 'react';

/**
 * Data management tab component
 * Handles data export and deletion operations
 */
const DataTab = ({ onExportClients, onExportJobs, onDeleteAllData }) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Data Export</h3>
        <div className="space-y-4">
          <div className="p-4 border border-gray-200 rounded-lg">
            <h4 className="font-medium text-gray-900 mb-2">Export Client Data</h4>
            <p className="text-sm text-gray-600 mb-4">
              Download all client information in CSV format
            </p>
            <button 
              onClick={onExportClients}
              className="bg-pest-blue hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors duration-200"
            >
              Export Clients
            </button>
          </div>

          <div className="p-4 border border-gray-200 rounded-lg">
            <h4 className="font-medium text-gray-900 mb-2">Export Job Data</h4>
            <p className="text-sm text-gray-600 mb-4">
              Download all job information and reports in CSV format
            </p>
            <button 
              onClick={onExportJobs}
              className="bg-pest-blue hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors duration-200"
            >
              Export Jobs
            </button>
          </div>
        </div>
      </div>

      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4 text-red-600">Danger Zone</h3>
        <div className="p-4 border border-red-200 rounded-lg bg-red-50">
          <h4 className="font-medium text-red-900 mb-2">Delete All Data</h4>
          <p className="text-sm text-red-700 mb-4">
            This will permanently delete all clients, jobs, and reports. This action cannot be undone.
          </p>
          <button 
            onClick={onDeleteAllData}
            className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg transition-colors duration-200"
          >
            Delete All Data
          </button>
        </div>
      </div>
    </div>
  );
};

export default DataTab;